/* eslint-disable @typescript-eslint/no-explicit-any */
import { createContext, useContext } from "react";
import { EmailHealthState } from "./email-health-provider";
import { DnsRecordsResponse } from "@/types/postman.types";

export type EmailHealthRecord =
  | {
      type: any;
      status: string;
      partialValid: string;
      description: any;
      record: {
        mailserver: any;
        domain: string | undefined;
      };
      result: string | boolean;
    }
  | {
      type: any;
      status: string;
      description: any;
      record: any;
      partialValid?: undefined;
      result?: undefined;
    };

type EmailHealthContextType = {
  recordsData: DnsRecordsResponse;
  isLoading: boolean;
  state: EmailHealthState;
  setState: React.Dispatch<React.SetStateAction<EmailHealthState>>;
  toggleCollapseAll: (type: "collapse" | "expand") => void;
  sortedRecords: EmailHealthRecord[];
};

export const EmailHealthContext = createContext<EmailHealthContextType | null>(
  null
);

export const useEmailHealthReport = () => {
  const context = useContext(EmailHealthContext);
  if (!context) {
    throw new Error(
      "useEmailHealthReport must be used within an EmailHealthProvider"
    );
  }
  return context;
};
